<script setup>
import { onMounted, computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useWizard } from 'dashboard/composables/useWizard';
import { useRouter } from 'vue-router';
import { openBillingOrSuperAdmin } from 'dashboard/helper/upgradeHelper';

import Banner from 'dashboard/components-next/banner/Banner.vue';

const router = useRouter();
const { accountId } = useAccount();

const { documentLimits, fetchLimits } = useWizard();

const openBilling = () => {
  openBillingOrSuperAdmin(router, accountId.value);
};

const showBanner = computed(() => {
  if (!documentLimits.value) return false;

  const { currentAvailable } = documentLimits.value;
  return currentAvailable === 0;
});

onMounted(fetchLimits);
</script>

<template>
  <Banner
    v-show="showBanner"
    color="amber"
    :action-label="$t('WIZARD.PAYWALL.UPGRADE_NOW')"
    @action="openBilling"
  >
    {{ $t('WIZARD.BANNER.DOCUMENTS') }}
  </Banner>
</template>
